import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getDisplayName } from '@grandvisionhq/utils';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../operations/mutations/signup-promotion.js';
import '../operations/mutations/subscribe-newsletter.js';
import '../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachPageable } from '../hooks/use-bloomreach-pageable.js';
import '../hooks/use-breakpoint-visibility.js';

function withBloomreachPageable(Component) {
    const displayName = getDisplayName(Component);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const WithBloomreachPageable = (props)=>{
        var ref;
        const { refs , data  } = useBloomreachPageable(props);
        if (!((ref = data.content.items) === null || ref === void 0 ? void 0 : ref.length)) {
            console.warn(`Trying to render Bloomreach pageable component: ${displayName}, but found no content documents. Refs: ${refs}`);
            return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props, {
                content: {
                    items: []
                }
            }));
        }
        return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, data, props));
    };
    WithBloomreachPageable.displayName = `WithBloomreachPageable(${displayName})`;
    return WithBloomreachPageable;
}

export { withBloomreachPageable };
//# sourceMappingURL=with-bloomreach-pageable.js.map
